import React from 'react';
import variables from '../../variables';

function LinkField({ value, maxLength }) {
  if (!value) return <>-</>;

  return (
    <a
      style={{
        color: variables.primary,
      }}
      href={value}
    >
      {value}
    </a>
  );
}

export default LinkField;
